import { Checkbox } from '@mui/material';
import { OnlyFansSubscriberHostessAutoReplyFreeloaders } from '../../../../types/hostessAutoReplyFreeloaders';

const FormSkipCreatorsCheckbox = (props: {
    formData: OnlyFansSubscriberHostessAutoReplyFreeloaders;
    setFormData: (formData: OnlyFansSubscriberHostessAutoReplyFreeloaders) => void;
}) => {
    const { formData, setFormData } = props;

    return (
        <Checkbox
            checked={formData && formData.excludeCreators ? true : false}
            size="medium"
            onChange={e => {
                setFormData({ ...formData, excludeCreators: e.target.checked });
            }}
            sx={{
                '& .MuiSvgIcon-root': {
                    fontSize: '1.5rem',
                },
            }}
        />
    );
};

export default FormSkipCreatorsCheckbox;
